import type { WidgetProps } from '@rjsf/utils';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { ReactElement } from 'react';

export function RadioWidget({ value, onChange, options, disabled, readonly }: WidgetProps): ReactElement {
  const enumOptions = (options.enumOptions ?? []) as { value: string; label: string }[];

  return (
    <ToggleButtonGroup
      exclusive
      value={value ?? null}
      onChange={(_, next) => { if (next !== null) onChange(next); }}
      disabled={disabled || readonly}
      fullWidth
      size="small"
      sx={{
        backgroundColor: '#F3F4F6',
        borderRadius: '8px',
        p: '3px',
        gap: '2px',
        '& .MuiToggleButton-root': {
          border: 'none',
          borderRadius: '6px !important',
          textTransform: 'none',
          fontSize: '0.875rem',
          py: '5px',
          color: 'text.secondary',
          '&.Mui-selected': {
            backgroundColor: '#ffffff',
            color: 'text.primary',
            boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
            '&:hover': { backgroundColor: '#ffffff' },
          },
          '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
        },
      }}
    >
      {enumOptions.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value}>
          {opt.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
